<template>
  <RoomAvailability></RoomAvailability>
</template>
<script>
import RoomAvailability from '../../reception/RoomAvailability.vue'
export default {
  components: {RoomAvailability}
}
</script>
